import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.sort.js";
import KivaProxy from "@/utils/kivaProxy/src";
var moment = require("moment");
export default {
  data: function data() {
    return {
      pins: [],
      // favoriteMenu:[],
      allMenuIdsPinned: [],
      loadingFavorite: false,
      keyfavorites: "keyfavorites"
    };
  },
  computed: {
    me: function me() {
      return _objectSpread({}, this.$store.state.users.CURRENT_USER);
    },
    favoriteMenu: {
      get: function get() {
        return this.$store.state.common.FAVORITES;
      },
      set: function set(val) {
        this.keyfavorites = 'kf' + Math.random(99, 99999999);
        Object.assign(this.$store.state.common.FAVORITES, val);
      }
    }
  },
  methods: {
    findMenuAll: function findMenuAll(favoriteType) {
      var _this = this;
      var routes = this.$router.options.routes;
      var allMenu = [];
      var allPart = [];
      var favoriteMenu = [];
      this.pins.forEach(function (nm) {
        var arr = nm.menu ? nm.menu.split("&&") : [];
        var menu = nm.menu;
        var part = 'none';
        if (arr[1]) {
          menu = arr[1];
          part = arr[0];
        }
        allMenu.push(menu);
        allPart.push(part);
      });
      routes.forEach(function (m1) {
        var index = allMenu.indexOf(m1.name);
        if (index > -1) {
          m1.pathFull = m1.path;
          m1.pin = _this.pins[index];
          m1.part = allPart[index] ? allPart[index] : 'none';
          favoriteMenu.push(m1);
        }
        if (m1.children && m1.children[0]) {
          m1.children.forEach(function (m2) {
            var index2 = allMenu.indexOf(m2.name);
            if (index2 > -1) {
              m2.pathFull = m1.path + '/' + m2.path;
              m2.pin = _this.pins[index2];
              m2.part = allPart[index2] ? allPart[index2] : 'none';
              favoriteMenu.push(m2);
            }
          });
        }
      });
      this.favoriteMenu[favoriteType] = favoriteMenu;
      this.favoriteMenu["allMenuIdsPinned"] = allMenu;
      this.allMenuIdsPinned = allMenu;
      this.keyfavorites = 'kf' + Math.random(99, 99999999);
    },
    getPins: function getPins(params) {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var force, favoriteType, limit, offset, filters, sort, dir;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              force = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              favoriteType = 2;
              if (params && params.favorite_type) {
                favoriteType = params.favorite_type;
              }
              if (!(_this2.favoriteMenu && _this2.favoriteMenu[favoriteType] && _this2.$store.state.common.FAVORITES[favoriteType][0] && force == false)) {
                _context.next = 7;
                break;
              }
              _this2.allMenuIdsPinned = _this2.favoriteMenu["allMenuIdsPinned"];
              _context.next = 20;
              break;
            case 7:
              limit = 200;
              offset = 0;
              filters = {};
              sort = 'created_on';
              dir = 'ASC';
              if (params && params.project && params.project.value) {
                filters.project = ["=", params.project.value];
              }
              if (params && params.collection) {
                filters.collection = ["=", params.collection];
              }
              if (params && params.favorite_type) {
                filters.favorite_type = ["=", params.favorite_type];
              }
              filters.record_owner = ["=", _this2.me.userId];
              if (params && params.sort) {
                sort = params.sort;
              }
              if (params && params.dir) {
                dir = params.dir;
              }
              _context.next = 20;
              return new KivaProxy({
                endpoint: "my/favorite"
              }).setFields(["record_id", "favorite_id", "project", "favorite_type", "menu", "record_owner", "created_on", "created_by", "last_modified_on", "last_modified_by"]).setFilters(filters).setLimit(limit).setStart(offset).setSort(sort).setDir(dir).all().then(function (response) {
                _this2.loadingFavorite = false;
                _this2.pins = response.records;
                _this2.findMenuAll(favoriteType);
              });
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    addPinToMenu: function addPinToMenu(menu, part) {
      var favorite_type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
      this.savePins({
        menu: menu,
        favorite_type: favorite_type,
        part: part
      });
    },
    removeToMenu: function removeToMenu(menuId) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return new KivaProxy({
                endpoint: 'my/favorite'
              }).destroy(menuId).then(function (response) {
                _this3.loadingFavorite = false;
                _this3.getPins(null, true);
              }).catch(function (err) {
                _this3.loadingFavorite = false;
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeToMenuFromPath: function removeToMenuFromPath(menu, part) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var num;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              num = _this4.allMenuIdsPinned.indexOf(menu);
              if (_this4.favoriteMenu[2]) {
                _this4.favoriteMenu[2].forEach(function (k) {
                  if (k.part == part && k.name == menu) {
                    if (k.pin && k.pin.record_id) {
                      _this4.removeToMenu(k.pin.record_id);
                    }
                  }
                });
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    savePins: function savePins() {
      var _arguments2 = arguments,
        _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var params;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
              if (params && params.part) {
                params.menu = params.part + "&&" + params.menu;
              }
              _context4.next = 4;
              return new KivaProxy({
                endpoint: 'my/favorite'
              }).create(params).then(function (response) {
                _this5.loadingFavorite = false;
                _this5.getPins(null, true);
              }).catch(function (err) {
                _this5.loadingFavorite = false;
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};